export const toggleToast = (message: string, toggleDispatch: any, timeout = 1000) => {
  toggleDispatch(true, message);
  setTimeout(toggleDispatch, timeout, false, '');
};